import { useEffect } from "react"
import { useQueryParams } from "./useQueryParams"
import { useDispatch, useSelector } from "react-redux"
import {
  selectPractice,
  selectSelectedLocation,
  updateSelectedLocation,
} from "../../domain/Practice/model"
import { AppDispatch } from "../../reduxStore/store"

/**
 * Custom hook for automatically selecting a location using the locationIdQueryParam.
 *
 * @returns {void}
 */
export const useSelectLocation = () => {
  const dispatch: AppDispatch = useDispatch()
  const { locationIdQueryParam } = useQueryParams()
  const practice = useSelector(selectPractice)
  const currentSelectedLocation = useSelector(selectSelectedLocation)

  useEffect(() => {
    if (!!locationIdQueryParam) {
      const newSelectedLocation = [
        ...practice.locations,
        practice.virtualLocation,
      ].find((location) => !!location && location.id === locationIdQueryParam)

      if (
        !!newSelectedLocation &&
        (!currentSelectedLocation ||
          newSelectedLocation.id !== currentSelectedLocation.id)
      ) {
        dispatch(updateSelectedLocation(newSelectedLocation))
      }
    }
  }, [
    locationIdQueryParam,
    practice.locations,
    practice.virtualLocation,
    dispatch,
    currentSelectedLocation,
  ])
}
